<template>
    <transition name="nebula-modal-transition" mode="out-in">
        <NebulaModal v-if="showRemoveModal" @close-modal="toggleRemoveModal" size="s">
            <template v-slot:header>
                <h2>Remove User</h2>
            </template>
            <template v-slot:content>
                <p>You are about to remove {{ modalStore.removeUserModal.email }} from Career Connect. Are you sure you want to proceed?</p>
            </template>
            <template v-slot:actionsRow>
                <NebulaButton @click="toggleRemoveModal" type="flat" text="No, cancel" />
                <NebulaButton @click="removeEmployee" text="Yes, proceed" />
            </template>
        </NebulaModal>
    </transition>
</template>

<script>
import { NebulaModal, NebulaButton } from '@discoveryedu/nebula-components';
import createPayload from '@/mixins/data/createPayload';
import { useMainStore } from '@/stores/useMainStore';
import { useModalStore } from '@/stores/useModalStore';
import { useOrganizationStore } from '@/stores/useOrganizationStore';

export default {
    setup() {
        const store = useMainStore();
        const modalStore = useModalStore();
        const orgStore = useOrganizationStore();
        return { store, modalStore, orgStore };
    },
    name: 'UserManagementModals',
    components: {
        NebulaModal,
        NebulaButton,
    },
    mixins: [createPayload],
    computed: {
        showRemoveModal() {
            return this.modalStore.removeUserModal.show;
        },
    },
    methods: {
        toggleRemoveModal() {
            this.modalStore.toggleModal({
                category: 'user_management',
                type: 'remove',
                show: !this.modalStore.removeUserModal.show,
            });
        },
        async removeEmployee() {
            const employeeData = this.modalStore.removeUserModal;
            const payload = await this.createPayload({ employeeId: employeeData.employeeId });
            await this.orgStore.removeEmployee(payload);
            this.modalStore.toggleModal({
                category: 'user_management',
                type: 'remove',
                show: !this.modalStore.removeUserModal.show,
            });

            const removalPayload = await this.createPayload();
            await this.orgStore.getOrganizationEmployees(removalPayload);
        },
    },
};
</script>
